import { Layer, LayerProps } from 'shared/map-exports';
import { useMapLayerEvents } from '../useMapLayerEvents';
import {
  ExternalFeatureLayerProps,
  ExternalFeatureProperties,
  ExternalLayerStylesInput,
} from './ExternalFeatureLayer.types';
import { useLayerClickHandler } from './useLayerClickHandler';

type LineLayerProps = ExternalFeatureLayerProps;

const getLineLayerStyles = (input: ExternalLayerStylesInput): LayerProps => {
  if (input.displayStyleType !== 'simple_single_color') {
    throw new Error(
      'Line layer styles require simple_single_color display style',
    );
  }
  const { sourceId, sourceLayer, color } = input;
  return {
    type: 'line',
    source: sourceId,
    'source-layer': sourceLayer,
    paint: {
      'line-color': color,
      'line-width': ['interpolate', ['linear'], ['zoom'], 8, 2, 18, 6],
    },
  };
};

export const LineLayer = (props: LineLayerProps): JSX.Element => {
  const {
    sourceId,
    featureLayer: { shortName, displayStyleData, displayName, geomType },
  } = props;
  const clickHandler = useLayerClickHandler(sourceId, displayName, geomType);

  useMapLayerEvents<ExternalFeatureProperties>({
    layerId: `${sourceId}_line`,
    onClick: clickHandler,
  });

  return (
    <Layer
      id={`${sourceId}_line`}
      {...getLineLayerStyles({
        sourceId,
        sourceLayer: shortName,
        ...displayStyleData,
      })}
    />
  );
};
